import { compose } from 'recompose';
import DistributorSalesTarget from './userFundamentalTarget';
import {
  query,
  mutation,
  UPLOAD,
  DOWNLOAD_REPORT,
} from './API';
import withRequestTracker from '../../../../utils/composition/withRequestTracker';

const ComposedDistributorSalesTarget = compose(
  UPLOAD,
  DOWNLOAD_REPORT,
  withRequestTracker({
    query,
    mutation,
  })
)(DistributorSalesTarget);


export default ComposedDistributorSalesTarget;
